import { FeedBackLevel } from '@chipinside/formbuilder'
import { Button, ButtonProps } from '@mui/material'
import { omit } from 'lodash'

type FormbuilderButtonProps = ButtonProps & {
  level?: FeedBackLevel
}

export function FormbuilderButton(props: FormbuilderButtonProps) {
  return <Button sx={{ minWidth: 100 }} {...omit(props, ['onPress'])} color={props.level} />
}
